module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGdc8febba2c72d746d86dc36969c9f626.dc8febba.png";